import React from "react";
import Select from "@common/components/Select";
import { SetupProducerFormType } from "..";
import { Assignee } from "@services/meetings/assignee";
import { User } from "@services/user/types";
import { useTranslation } from "react-i18next";
import { MenuItem } from "@mui/material";

type ChangeProducerProps = {
  producer: User | { id: string };
  dispatch: React.Dispatch<"reset" | Partial<SetupProducerFormType>>;
  assignees: Assignee[];
};
const ChangeProducer = (props: ChangeProducerProps) => {
  const { producer, dispatch, assignees } = props;
  const { t } = useTranslation();
  return (
    <Select
      label={t("Preferred producer")}
      value={producer.id}
      onChange={(event) =>
        dispatch({
          producer: (assignees.find(
            (assignee) => assignee.id === event.target.value
          ) ?? { id: "" }) as User,
        })
      }
    >
      <MenuItem value={""}>
        <br />
      </MenuItem>
      {[...assignees]
        .sort((a, b) =>
          `${a.firstName} ${a.lastName}`
            .toLowerCase()
            .localeCompare(`${b.firstName} ${b.lastName}`.toLowerCase())
        )
        .map((assignee) => (
          <MenuItem key={assignee.id} value={assignee.id}>
            {assignee.firstName} {assignee.lastName}
          </MenuItem>
        ))}
    </Select>
  );
};

export default ChangeProducer;
